import { authedAxios } from "../utils/customHttpHeader";

const bookingList = async (payload, endpoint) => {
  let url = `${endpoint}/?hotelId=${payload.hotelId}`;

  if (payload.startDate) url += `&startDate=${payload.startDate}`;

  if (payload.endDate) url += `&endDate=${payload.endDate}`;

  if (payload.statuses) url += `&statuses=${payload.statuses}`;

  // if (payload.pageSize) url += `&pageSize=${payload.pageSize}`;

  if (payload?.paginationEnabled) url += `&paginationEnabled=${false}`;
  const response = await authedAxios().get(url);
  return response.data;
};

export async function getRoomAvailabilityList({ hotelId, startDate, endDate }) {
  const response = await authedAxios().get("/rooms/date-wise-availability", {
    params: { hotelId, startDate, endDate },
  });
  return response.data;
}

export { bookingList };
